// Saudi-specific lists and digit helpers used by the profile and the sell flow. Cities are kept in sync with
// server/src/lib/cities.ts; the server checks everything again.

export const SA_CITIES: { en: string; ar: string }[] = [
  { en: "Riyadh", ar: "الرياض" },
  { en: "Jeddah", ar: "جدة" },
  { en: "Makkah", ar: "مكة المكرمة" },
  { en: "Madinah", ar: "المدينة المنورة" },
  { en: "Dammam", ar: "الدمام" },
  { en: "Khobar", ar: "الخبر" },
  { en: "Dhahran", ar: "الظهران" },
  { en: "Jubail", ar: "الجبيل" },
  { en: "Al Ahsa", ar: "الأحساء" },
  { en: "Qatif", ar: "القطيف" },
  { en: "Hafr Al Batin", ar: "حفر الباطن" },
  { en: "Taif", ar: "الطائف" },
  { en: "Buraydah", ar: "بريدة" },
  { en: "Unaizah", ar: "عنيزة" },
  { en: "Hail", ar: "حائل" },
  { en: "Tabuk", ar: "تبوك" },
  { en: "Abha", ar: "أبها" },
  { en: "Khamis Mushait", ar: "خميس مشيط" },
  { en: "Najran", ar: "نجران" },
  { en: "Jazan", ar: "جازان" },
  { en: "Al Baha", ar: "الباحة" },
  { en: "Arar", ar: "عرعر" },
  { en: "Sakaka", ar: "سكاكا" },
  { en: "Yanbu", ar: "ينبع" },
  { en: "Al Kharj", ar: "الخرج" },
  { en: "Al Majmaah", ar: "المجمعة" },
  { en: "Al Qurayyat", ar: "القريات" },
  { en: "Bisha", ar: "بيشة" },
];

/** City name in the reader's language. Older free-text values (either language) are matched too. */
export function cityName(value: string | null | undefined, locale: "en" | "ar"): string {
  if (!value) return "";
  const c = SA_CITIES.find((x) => x.en === value || x.ar === value);
  return c ? c[locale] : value;
}

/** The list sorted for the reader's language. */
export const citiesFor = (locale: "en" | "ar") => [...SA_CITIES].sort((a, b) => a[locale].localeCompare(b[locale], locale));

export const westernDigits = (s: string) =>
  s.replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660)).replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0));

/** Keeps only digits (after converting Arabic-Indic ones), up to `max`. */
export const onlyDigits = (s: string, max: number) => westernDigits(s).replace(/\D/g, "").slice(0, max);
